import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'
import { 
  supabaseConfig, 
  authConfig, 
  realtimeConfig, 
  globalHeaders 
} from './config'

export const supabase = createClient<Database>(
  supabaseConfig.url, 
  supabaseConfig.anonKey, 
  {
    auth: authConfig,
    global: {
      headers: globalHeaders,
    },
    realtime: realtimeConfig,
  }
)
